export function Uint8ToBlob(data: Uint8Array, type?: string): Blob {
  return new Blob([data as Uint8Array<ArrayBuffer>], { type })
}
// No default export, only named exports
